export { createPageViewCounter } from './counter.ts'
export { mountPageViews } from './mount.ts'
export type { PageViewCounter, PageViewMountOptions } from './types.ts'
